import { render } from "./App.vue?vue&type=template&id=94f5f080"
const script = {}

import exportComponent from "/var/www/html/giulietta/giulietta/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__